import { render } from "./DashboardDropdownRender.vue?vue&type=template&id=174426bf&scoped=true"
import script from "./DashboardDropdownRender.vue?vue&type=script&lang=js"
export * from "./DashboardDropdownRender.vue?vue&type=script&lang=js"

import "./DashboardDropdownRender.vue?vue&type=style&index=0&id=174426bf&lang=less&scoped=true"

import exportComponent from "/Users/cain/Workspaces/projects/roar/roar-fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.30_vue@3.5.30_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174426bf"]])

export default __exports__